import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ItemServiceProvider } from './../../../_services/services';
import { ItemDetails } from './../../../_models/item/item-details.model';

import utils from './../../../utils';
import { LocationListComponent } from '../location-list/location-list.component';
import { ServiceLocator } from '../../../locater.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogCloseService } from 'src/app/_services/dialogClose.service';

import Utils from './../../../utils';
import { ItemSearchType } from 'src/app/enums';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { LoadingService } from 'src/app/_services/loading.service';
//import { ItemSearchComponent } from '../item-search/item-search.component';

@Component({
    selector: 'app-item-list',
    templateUrl: './item-list.component.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule,
        LocationListComponent
    ],
})
export class ItemListComponent {
    //  @ViewChild('itemSearch') itemSearchComponent!: ItemSearchComponent;
    items: ItemDetails;
    selectedItemDetails: ItemDetails;
    showQuantityOfAllLocations: boolean;

    @Input() itemsDetailList: ItemDetails[];
    @Output() sendResponseEventEmitter = new EventEmitter<any>();
    @Input() showLocationDetails: boolean = false;
    @Input() forSalesOrder: boolean;
    @Input() isLocationSelectable: boolean = false;
    @Input() itemSearchType: any;
    @Input() isFarmAndFieldSelected: boolean = false;

    showRecords: boolean;

    constructor(
        private itemService: ItemServiceProvider,
        public dialog: MatDialog,
        private closeDialogService: DialogCloseService,
        private blockUI: LoadingService) {
        this.items = new ItemDetails();
        this.showQuantityOfAllLocations = utils.getShowQuantityOfAllLocations();
        this.isLocationSelectable = true;

    }

    async itemSelect(selectedItem: ItemDetails) {

        // console.log('Item selected:', selectedItem);

        // // Emit a signal to cancel all pending requests
        // if (this.itemSearchComponent) {
        //     this.itemSearchComponent.cancelRequests();
        // }



        if (this.itemSearchType == ItemSearchType.Items) return;
        if (!selectedItem.isOnHandAndPositionLoaded) return;
        if (!this.forSalesOrder) {
            if (selectedItem && selectedItem.itemBalance) {
                selectedItem.itemBalance.OnHandQuantity = 0;

                if (!this.showLocationDetails) {
                    // selectedItem.selectedItemLocations = await this.getItemLocations(selectedItem.itemId);
                    selectedItem.itemBalance.Location = Utils.getLocation();
                    // console.log(selectedItem);
                }


            }

        }


        this.sendResponseEventEmitter.emit(selectedItem);

    }

    async getItemLocations(itemId: string): Promise<any[]> {
        this.blockUI.start();
        let locations: any[] = [];
        var mergeLocations = [];
        try {
            locations = await this.itemService.getOnhandForItemOnLocationFromAgris(itemId, true);
            if (locations && locations.length) {
                let locationCodes = locations.map(x => x.Location);
                locationCodes = [...new Set(locationCodes)];

                locationCodes.forEach((code: any, index: number) => {
                    let mergeLocation: any = {};
                    let OnHandQuantity = locations.filter(x => x.Location == code).map(y => y.OnHandQuantity);
                    mergeLocation.OnHandQuantity = OnHandQuantity.reduce((a: number, b: number) => a + b, 0);

                    let PositionQuantity = locations.filter(x => x.Location == code).map(y => y.PositionQuantity);
                    mergeLocation.PositionQuantity = PositionQuantity.reduce((a: number, b: number) => a + b, 0);

                    mergeLocation.Location = code;

                    let LocationDV = locations.filter(x => x.Location == code).map(y => y.LocationDV);
                    mergeLocation.LocationDV = LocationDV[0];
                    mergeLocation.LocationDV = mergeLocation.LocationDV.replace(mergeLocation.Location, "");


                    mergeLocations.push(mergeLocation);
                });
            }
            return mergeLocations;
        }
        catch (ex) {
            console.log(ex);
            return [];
        }
        finally {
            this.blockUI.stop();
        }
    }


    async showOnhandOnOtherLocations(selectedItem: ItemDetails) {
        try {
            this.blockUI.start();
            let locations: any = await this.itemService.getOnhandForItemOnLocationFromAgris(selectedItem.id);

            if (locations && locations.length) {
                var mergeLocations = [];
                let locationCodes = locations.map(x => x.Location);
                locationCodes = [...new Set(locationCodes)];

                locationCodes.forEach((code: any, index: number) => {
                    let mergeLocation: any = {};
                    let OnHandQuantity = locations.filter(x => x.Location == code).map(y => y.OnHandQuantity);
                    mergeLocation.OnHandQuantity = OnHandQuantity.reduce((a: number, b: number) => a + b, 0);

                    let PositionQuantity = locations.filter(x => x.Location == code).map(y => y.PositionQuantity);
                    mergeLocation.PositionQuantity = PositionQuantity.reduce((a: number, b: number) => a + b, 0);

                    mergeLocation.Location = code;

                    let LocationDV = locations.filter(x => x.Location == code).map(y => y.LocationDV);
                    mergeLocation.LocationDV = LocationDV[0];
                    mergeLocation.LocationDV = mergeLocation.LocationDV.replace(mergeLocation.Location, "");


                    mergeLocations.push(mergeLocation);
                });


                // console.log("locations =>", locations);
                // console.log("mergeLocations =>", mergeLocations);


                this.locationDialog(selectedItem, mergeLocations, false, '');
            } else {
                this.locationDialog(selectedItem, [], false, "No quantities for this item at other locations.");
            }
        }
        catch (ex) {
            if (ex.Code == 404) {
                this.locationDialog(selectedItem, [], false, "No quantities for this item at other locations.");
                return;
            }
            throw ex;
        }
        finally {
            this.blockUI.stop();
        }

        // this.blockUI.start();
        // this.itemService.getOnhandForItemOnLocation(selectedItem.id, (data => {
        //     this.blockUI.stop();
        //     if (data.result === true) {
        //         // let itemName = `${selectedItem.descriptionPartial1of3}`;
        //         // let itemId = selectedItem.id;
        //         this.locationDialog(selectedItem, data.locations, false, '')
        //     } else {
        //         this.locationDialog(selectedItem, [], true, data.message)
        //     }
        // }))
    }

    locationDialog(selectedItem: ItemDetails, data: any, error: any, errorMessage: any) {
        let dialogRef = this.dialog.open(LocationListComponent,
            {
                minWidth: '50%',
                minHeight: '290px',
                panelClass: 'custom-modalbox',
                data: {
                    itemName: selectedItem.descriptionPartial1of3,
                    locations: data,
                    error: error,
                    errorMessage: errorMessage,
                    isLocationSelectable: this.isLocationSelectable,
                }
            });
        dialogRef.afterClosed().subscribe(result => {
            // this.items.location = result.Code;
            // console.log("SelectedItem =>", selectedItem);
            console.log("SelectedLocation", result);


        });
        this.closeDialogService.emitRegisterDialog(dialogRef);
    }


}